import { createListenerMiddleware } from '@reduxjs/toolkit';
import { createListenerEffect } from '@socialive/common';
import { GUEST_LINK_EROR_MESSAGE } from '~/helpers/constants';
import { JoinBroadcastLinkType } from '~/helpers/enums';
import trackMixPanelEvent from '~/helpers/trackMixPanelEvent';
import { getSessionFromGuestLink } from '~/store/accountInfo';
import { getBroadcast, setLinkType } from '~/store/joinBroadcast';

const EVENT_NAME = 'Guest link used';

const STATUS_EROR = new Map([
  [GUEST_LINK_EROR_MESSAGE.FORBIDDEN, 'Not a guest'],
  [GUEST_LINK_EROR_MESSAGE.NOT_FOUND, 'Broadcast closed'],
  [GUEST_LINK_EROR_MESSAGE.DEFAULT, 'Error'],
]);

export const effect = createListenerEffect(
  'trackGuestLinkEvent<Listener>',
  async ({ payload: { type } }, { dispatch, getState, unsubscribe, take, trigger }) => {
    unsubscribe();

    if (type === JoinBroadcastLinkType.GUEST) {
      const [{ error }] = await take(
        (action) =>
          action.type === getSessionFromGuestLink.fulfilled.type ||
          action.type === getSessionFromGuestLink.rejected.type
      );

      if (error) {
        trackMixPanelEvent(EVENT_NAME, {
          'Link type': type,
          'Link status': 'Expired',
        });
        return;
      }
    }

    const [{ error }] = await take(
      (action) => action.type === getBroadcast.fulfilled.type || action.type === getBroadcast.rejected.type
    );

    if (error) {
      trackMixPanelEvent(EVENT_NAME, {
        'Link type': type,
        'Link status': STATUS_EROR.get(error.message) ?? 'Error',
      });
      return;
    }

    trackMixPanelEvent(EVENT_NAME, {
      'Link type': type,
      'Link status': 'Successful',
    });
  }
);

const { startListening, middleware } = createListenerMiddleware();

startListening({
  actionCreator: setLinkType,
  effect,
});

export default middleware;
